import React, { useState, useCallback } from "react";
import "./With.css";
import axios from "axios";
import { useEffect } from "react";
import ContractDetails from "../../Contracts/ContractDetails";
import { Container, Row, Col } from "react-bootstrap";
import { ethers } from "ethers";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toastFailed, toastSuccess } from "../../Common/Data";
import {
  approveWithdrawalRequests,
  fetchAllTransaction,
  rejectWithdrawalRequest,
} from "../../Actions/adminActions";
import { useDispatch } from "react-redux";
import Tether from "../../Images/tether-usdt-logo.png";
import apiCall from "../../API/API";
import GetChainId from "../../Common/GetChainId";

const PrWithdrawnDetails = () => {
  const { BigInt } = window;
  const location = useLocation();
  const account = useSelector((state) => state.accounts.value);
  const [usdt, setUsdt] = useState(false);
  const [atm, setAtm] = useState(false);
  const [show, setShow] = useState(false);
  const {
    amountArray = [],
    walletAddressArray = [],
    usernameArray = [],
    tx_IdsArray = [],
  } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedToken, setSelectedToken] = useState();
  const [companyDetails, setCompanyDetails] = useState();

  console.log("foqr", amountArray)

  async function increaseAllowance(amountArray, walletAddressArray) {
    try {
      const { ethereum } = window;
      if (!ethereum) {
        console.log("Ethereum provider not found");
        return;
      }

      if (
        !Array.isArray(amountArray) ||
        !Array.isArray(walletAddressArray) ||
        amountArray.length === 0 ||
        walletAddressArray.length === 0 ||
        amountArray.length !== walletAddressArray.length
      ) {
        console.log("Invalid amount or wallet addresses");
        return;
      }
      if (account != null && account.length > 0) {
        const chain = await GetChainId();
        if (chain == false) {
          // setLoading(false);
          return;
        }
        console.log("amountArray", amountArray);

        const newAmount = amountArray.map((amount) => {
          console.log("amount", amount);

          const parsedAmount = ethers.utils.parseUnits(amount.toString(), 18);
          console.log("parsedAmount", parsedAmount.toString());

          return parsedAmount;
        });
        console.log(
          "Parsed Amounts:",
          newAmount.map((a) => a.toString())
        );

        const totalAmount = newAmount.reduce(
          (acc, amount) => acc.add(amount),
          ethers.BigNumber.from(0)
        );

        console.log("Total Parsed Amount:", totalAmount.toString());

        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        let busdInstance;
        // if (selectedToken?.address == ContractDetails.BUSD) {
        busdInstance = new ethers.Contract(
          ContractDetails.BUSD,
          ContractDetails.BUSD_ABI,
          signer
        );
        // } else if (selectedToken?.address == ContractDetails.ATMToken) {
        //   busdInstance = new ethers.Contract(
        //     ContractDetails.ATMToken,
        //     ContractDetails.ATMTokenABI,
        //     signer
        //   );
        // }
        let inc = await busdInstance.increaseAllowance(
          ContractDetails.contract,
          totalAmount
        );
        console.log(inc);
        shareDistribution(newAmount, walletAddressArray);
      } else {
        toastFailed("Connect your wallet");
      }
    } catch (error) {
      console.error("Withdrawal failed:", error);
      toastFailed(error?.error?.data?.message);
    }
  }

  async function shareDistribution(newAmount, walletAddressArray) {
    try {
      const { ethereum } = window;
      if (!ethereum) {
        console.log("Ethereum provider not found");
        return;
      }
      console.log("aaaaaa", newAmount);
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      const busdInstance = new ethers.Contract(
        ContractDetails.contract,
        ContractDetails.contractABI,
        signer
      );

      let inc = await busdInstance.sendUSDTToMultipleAddresses(
        newAmount,
        walletAddressArray
      );
      console.log("1111111111111111", inc);
      console.log("hash", inc?.hash);
      toastSuccess("Withdrawan successfully");
      navigate("/dashboard");
      await dispatch(
        approveWithdrawalRequests(
          tx_IdsArray,
          // selectedToken?.tokenSymbol,
          // selectedToken?.address,
          inc?.hash
        )
      );
    } catch (error) {
      console.error("Withdrawal failed:", error);
      toastFailed(error?.error?.data?.message);
    }
  }

  const handleToken = (token) => {
    console.log("token details", token);
    setSelectedToken(token);
    setShow(false);
  };

  useEffect(() => {
    if (selectedToken) {
      console.log("token is selected!");
      console.log("amountArray", amountArray);
      console.log("walletAddressArray", walletAddressArray);
      increaseAllowance(amountArray, walletAddressArray);
      // handleWithDap();
    }
  }, [selectedToken]);

  const handleWithDap = () => {
    increaseAllowance(amountArray, walletAddressArray);
    // shareDistribution(amountArray, walletAddressArray);
  };

  const handleNotWithDap = () => {
    navigate("/dashboard/principal_withdrawal");
  };

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);

  return (
    <React.Fragment>
      <Container>
        {show && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Select Token For Withdrawal</h2>
              <div className="tokenSelection">
                {companyDetails?.tokens
                  ?.filter((token) => token.enabled === 1)
                  ?.map((token, i) => (
                    <div
                      key={i}
                      className="tokenDiv"
                      onClick={() => handleToken(token)}
                    >
                      <span>{token?.tokenName}</span>
                      {token?.token_image?.startsWith("<svg") ? (
                        <span
                          style={{ marginLeft: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: token?.token_image,
                          }}
                        />
                      ) : (
                        <img
                          src={token?.token_image}
                          alt={token?.tokenSymbol}
                          style={{ marginLeft: "5px", height: "40px" }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        <div id="directIncomeDiv">
          <div className="button-container">
            <button
              className="action-btn"
              // onClick={() => setShow(true)}
              onClick={handleWithDap}
            >
              Proceed
            </button>
            <button className="action-btn" onClick={handleNotWithDap}>
              Cancel
            </button>
          </div>

          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Username</th>
                    <th>Wallet Address</th>
                    <th>Amount</th>
                  </tr>
                  <tbody>
                    {amountArray.map((amount, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{usernameArray[i]}</td>
                        <td>{walletAddressArray[i]}</td>
                        <td>{amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default PrWithdrawnDetails;
